module.exports = __webpack_public_path__ + "img/zapparoli.52eea663.svg";